import { load, ReCaptchaInstance } from "recaptcha-v3";

let recaptchaInstance: ReCaptchaInstance | null = null;

export default async function () {
  const siteKey = import.meta.env.VITE_CAPTCHA_SITE_KEY;

  if (!siteKey) {
    console.warn("ReCaptcha site key is not configured");
    return;
  }

  try {
    recaptchaInstance = await load(siteKey, {
      autoHideBadge: false,
    });
  } catch (error) {
    console.error("Failed to load ReCaptcha:", error);
  }
}

export function useCaptcha() {
  async function submit(action: string): Promise<string> {
    if (import.meta.env.VITE_APP_ENV === "development") {
      console.warn("ReCaptcha bypass, no cap. You are currently in development environment.");
      return "no-cap";
    }

    if (!recaptchaInstance) {
      throw new Error("ReCaptcha instance is not available. Make sure the plugin is installed.");
    }

    return recaptchaInstance.execute(action);
  }

  return {
    submit,
  };
}
